import React, { PureComponent } from 'react';
import { endpoint } from '../../helpers/constantes';
import SweetAlert from 'react-bootstrap-sweetalert';
import Paper from '@material-ui/core/Paper';
import {
  Grid,
  Table,
  Toolbar,
  SearchPanel,
  TableHeaderRow,
  PagingPanel,
  TableEditRow,
  TableEditColumn,
} from '@devexpress/dx-react-grid-material-ui';
import  Navigation from '../Navigation/Navigation'
import {
  SearchState,
  IntegratedFiltering,
  PagingState,
  IntegratedPaging,
  EditingState
} from '@devexpress/dx-react-grid';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { modificaLoader } from '../../actions/LoaderActions';
import './Lista.css';
import { modificaToken, modificaNome } from '../../actions/LoginActions';

const getRowId = row => row.id;
const EditButton = ({ onExecute }) => (
  <IconButton onClick={onExecute} title="Edit row">
    <EditIcon />
  </IconButton>
);

const DeleteButton = ({ onExecute }) => (
  <IconButton onClick={onExecute} title="Delete row">
    <DeleteIcon />
  </IconButton>
);

const CommitButton = ({ onExecute }) => (
  <IconButton onClick={onExecute} title="Save changes">
    <SaveIcon />
  </IconButton>
);

const CancelButton = ({ onExecute }) => (
  <IconButton color="secondary" onClick={onExecute} title="Cancel changes">
    <CancelIcon />
  </IconButton>
);

const commandComponents = {
  edit: EditButton,
  delete: DeleteButton,
  commit: CommitButton,
  cancel: CancelButton,
};

const Command = ({ id, onExecute }) => {
  const CommandButton = commandComponents[id];
  return (
    <CommandButton
      onExecute={onExecute}
    />
  );
};

class listaUsuarios extends PureComponent {
  constructor(props) {
    super(props);
    this.props.modificaLoader(true);
    this.state = {
      columns: [
        { name: 'nome', title: 'Nome' },
        { name: 'usuario', title: 'Usuário' },
      ],
      rows: [],
      pageSizes: [5, 10, 15, 0],
      deleted: '',
      alert: {
        show: false,      
        title: 'Aviso',
        message: '',
        type: {
          warning: false,
          success: false,
          danger: false,
        }
      }
    };
    this.listaUsuarios();
    
  }

  listaUsuarios = () => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${this.props.token}`)
    fetch(`${endpoint}/users`, {
      method: "GET",
      headers: myHeaders,
    })
    .then(result => {
      if(result.ok){
        return result.json();
      }else{
        this.setState({
          alert: {
            show: true,
            title: 'Falha',
            message: result.statusText,
            type: {
              warning: true,
              success: false,
              danger: false,
            }
          }
        })
      }
      throw Error("Forbidden");
    })
    .then(resultJson => {
      const resultFormated = resultJson.map(item => {
        return {
          id: item.id,
          nome: item.nome,
          usuario: item.usuario,
        }
      })
      this.setState({rows: resultFormated})
      this.props.modificaLoader(false);
    })
    .catch(err => {
      this.setState({
        alert: {
          show: true,
          title: 'Falha',
          message: err.message,
          type: {
            warning: false,
            success: false,
            danger: true,
          }
        }
      })
    })
  }

  updateUser = (obj) => {
    const { id, usuario, nome } = obj;
    const body = {
      user: usuario,
      nome
    }
    console.log('NEWOBJ', body);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${this.props.token}`)
    fetch(`${endpoint}/user/${id}`, {
      method: "PUT",
      headers: myHeaders,
      body: JSON.stringify(body)})
      .then(result => {
        if(result.ok){
          return;
        }else{
          this.setState({
            alert: {
              show: true,
              title: 'Falha ao atualizar Usuário',
              message: result.statusText,
              type: {
                warning: true,
                success: false,
                danger: false,
              }
            }
          })
        }
      })
      .catch(err => {
        this.setState({
          alert: {
            show: true,
            title: 'Erro! Estamos sem conectividade ?',
            message: err.message,
            type: {
              warning: false,
              success: false,
              danger: true,
            }
          }
        })
      })
  }

  deleteUser = (id) => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${this.props.token}`)
    fetch(`${endpoint}/user/${id}`, {
      method: "DELETE",
      headers: myHeaders,
    })
    .then(result => {
      if(result.ok){
        return;
      }else{
        this.setState({
          alert: {
            show: true,
            title: 'Falha ao deletar usuário',
            message: result.statusText,
            type: {
              warning: true,
              success: false,
              danger: false,
            }
          }
        })
      }
    })
    .catch(err => {
      this.setState({
        alert: {
          show: true,
          title: 'Erro! Estamos sem conectividade ?',
          message: err.message,
          type: {
            warning: false,
            success: false,
            danger: true,
          }
        }
      })
    })
  }

  commitChanges = ({ added, changed, deleted }) => {
    let { rows } = this.state;   
    if (changed) {
      rows = rows.map(row => {
        if(changed[row.id]) {
          row[Object.keys(changed[row.id])] = changed[row.id][Object.keys(changed[row.id])];
          this.updateUser(row);
          return {...row, ...changed[row.id] }
        }else{
          return row
        }
      })      
    }
    if (deleted) {      
      this.setState({ deleted });
    }
    this.setState({ rows });
  }

  confirmDelete = () => {
    let { rows, deleted } = this.state; 
    const deletedSet = new Set(deleted);
    this.deleteUser(deleted);
    rows = rows.filter(row => !deletedSet.has(row.id));
    this.setState({ deleted: '', rows });
  }

  render() {
    const { rows, columns, pageSizes  } = this.state;

    return (
      <Navigation history={this.props.history}>
        <div className="alinhamento">
          <h1>Edição de usuários</h1>
          <Paper>
            <Grid
              rows={rows}
              columns={columns}
              getRowId={getRowId}
            >
              <SearchState defaultValue="" />
              <IntegratedFiltering />
              <PagingState
                defaultCurrentPage={0}
                defaultPageSize={5}
              />
              <IntegratedPaging />
              <EditingState
              onCommitChanges={this.commitChanges}
              />          
              <Table />
              <TableHeaderRow />
              <TableEditRow />
              <PagingPanel
              pageSizes={pageSizes}
              />
              <TableEditColumn
              showEditCommand
              showDeleteCommand
              commandComponent={Command}
              />
              <Toolbar />
              <SearchPanel />
            </Grid>          
            <Dialog
            open={!!this.state.deleted}
            >
            <DialogTitle>
  Deletar usuário
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Você tem certeza que deseja apagar este usuário?
              </DialogContentText>
              <Paper>
                <Grid
                  rows={this.state.rows.filter(row => this.state.deleted.indexOf(row.id) > -1)}
                  columns={columns}
                >
                <Table />
                <TableHeaderRow />
                </Grid>
              </Paper>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ deleted: '' })} color="primary">
  Cancelar
              </Button>
              <Button onClick={this.confirmDelete} color="secondary">
  Deletar
              </Button>
            </DialogActions>
          </Dialog>
          </Paper>
        </div>
        <SweetAlert {...this.state.alert.type}
                title={this.state.alert.title}
                show={this.state.alert.show}
                onConfirm={() => this.setState({ ...this.state, alert: {show: false, title: ''}})}>
                {this.state.alert.message}
        </SweetAlert>
      </Navigation>
    );
  }
}

const mapStateToProps = state => ({
  token: state.LoginReducer.token,
});

export default connect(mapStateToProps, { modificaToken, modificaNome, modificaLoader })(listaUsuarios);



// WEBPACK FOOTER //
// ./src/components/Usuarios/Lista.js